// @flow
import uuid from 'uuid';
import i18n from 'i18n-js';

import * as gateActions from '../../../actions/gates';

export const validate = (values: Object) => {
  const {
    name,
    ordinal,
  } = values;

  const errors = {};

  if (!name) {
    errors.name = i18n.t('labels.requiredField');
  }

  if (!ordinal) {
    errors.ordinal = i18n.t('labels.requiredField');
  }
  return errors;
};

export const onSubmit = (values: Object, dispatch: Function, _props: Object) => {
  const {
    name,
    ordinal,
  } = values;
  dispatch(gateActions.gateCreateStarted(
    {
      id: uuid(),
      name,
      ordinal,
      type: 3,
    },
  ));
};



// WEBPACK FOOTER //
// ./src/scripts/components/CreateGatePopupContent/CreateGatePopupForm/utils.js